export default __webpack_public_path__ + "static/media/weatherImg.d23e4afd.png";